export const BhHeaderV2Lang: any = {
    en: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Shop Now',
        more: 'Learn More',

        label: {
            Hot: 'Hot',
            New: 'New',
            Sale: 'Sale',
        },
    },
    cis: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Купить сейчас',
        more: 'Узнать больше',
        label: {
            Hot: 'Популярное',
            New: 'Новинка',
            Sale: 'Распродажа',
        },
    },
    cn: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: '立即购买',
        more: '了解更多',
        label: {
            Hot: '热门',
            New: '新品',
            Sale: '折扣',
        },
    },
    de: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Jetzt shoppen',
        more: 'Mehr erfahren',
        label: {
            Hot: 'Beliebt',
            New: 'Neu',
            Sale: 'Angebot',
        },
    },
    es: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Comprar ahora',
        more: 'Más información',
        label: {
            Hot: 'Popular',
            New: 'Nuevo',
            Sale: 'Oferta',
        },
    },
    fr: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Acheter',
        more: 'Découvrir',
        label: {
            Hot: 'Populaire',
            New: 'Nouveau',
            Sale: 'Promo',
        },
    },
    hk: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: '立即購買',
        more: '了解更多',
        label: {
            Hot: '熱銷',
            New: '新品',
            Sale: '折扣',
        },
    },
    it: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Acquista ora',
        more: 'Ulteriori informazioni',
        label: {
            Hot: 'Popolare',
            New: 'Nuovo',
            Sale: 'Promo',
        },
    },
    jp: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: '今すぐ購入',
        more: '詳しくはこちら',
        label: {
            Hot: '人気商品',
            New: '新発売',
            Sale: 'セール',
        },
    },
    kr: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: '지금 구매하기',
        more: '더 알아보기',
        label: {
            Hot: '인기상품',
            New: '새제품',
            Sale: '세일',
        },
    },
    sa: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'تسوق الآن',
        more: 'اعرف المزيد',
        label: {
            Hot: 'رائج',
            New: 'جديد',
            Sale: 'تخفيض',
        },
    },
    tw: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: '立即購買',
        more: '了解更多',
        label: {
            Hot: '熱銷',
            New: '新品',
            Sale: '折扣',
        },
    },
    br: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Comprar agora',
        more: 'Saiba mais',
        label: {
            Hot: 'Em Alta',
            New: 'Novo',
            Sale: 'Promoção',
        },
    },
    mx: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'United States(English)',
        buy: 'Comprar ahora',
        more: 'Más información',
        label: {
            Hot: 'Popular',
            New: 'Nuevo',
            Sale: 'Oferta',
        },
    },
    nl: {
        logo_title: 'De nummer 1 slimme energieoplossing voor thuis.',
        login_register: 'Inloggen/Registreren',
        my_account: 'Mijn account',
        locale_title: 'United States(English)',
        buy: 'Nu winkelen',
        more: 'Meer informatie',
        label: {
            Hot: 'Heet',
            New: 'Nieuw',
            Sale: 'Verkoop',
        },
    },
    global: {
        logo_title: 'No.1 Smart Home Energy Solution',
        login_register: 'Login/Register',
        my_account: 'My Account',
        locale_title: 'Global(English)',
        buy: 'Shop Now',
        more: 'Learn More',

        label: {
            Hot: 'Hot',
            New: 'New',
            Sale: 'Sale',
        },
    },
};
